<template>
<div class="chapter">
<div class="inner_page">
<div class="plm_hd">CONTENTS</div>
<div class="sgc-toc-level-1">
<a href="#/Text/Dan_GenPref">General preface</a>
</div>
<div class="sgc-toc-level-1">
<a href="#/Text/Dan_AutPref">Author’s preface</a>
</div>
<div class="sgc-toc-level-1">
<a href="#/Text/Dan_Abbrev">Chief abbreviations</a>
<div class="sgc-toc-level-2">
<a href="#/Text/Dan_Abbrev#sigil_toc_id_1">Bible versions</a>
</div>
</div>
<div class="sgc-toc-level-1">
<a href="#/Text/Dan_Biblio">Select bibliography</a>
</div>
<div class="sgc-toc-level-1s">
<a href="#/Text/Dan_Intro"><span class="bold">Introduction</span></a>
<div class="sgc-toc-level-2">
<a href="#/Text/Dan_Intro#sigil_toc_id_2">1. Historical elements</a>
<div class="sgc-toc-level-3">
<a href="#/Text/Dan_Intro#sigil_toc_id_3">a. Overview</a>
</div>
<div class="sgc-toc-level-3">
<a href="#/Text/Dan_Intro#sigil_toc_id_4">b. Nabopolassar, Nebuchadnezzar and the Babylonian Empire (Daniel 1 – 4)</a>
</div>
<div class="sgc-toc-level-3">
<a href="#/Text/Dan_Intro#sigil_toc_id_5">c. Nebuchadnezzar’s successors and Babylon’s decline (Daniel 5:1–30)</a>
</div>
<div class="sgc-toc-level-3">
<a href="#/Text/Dan_Intro#sigil_toc_id_6">d. Cyrus and Babylon’s downfall (Daniel 5:31 – 6:28)</a>
</div>
<div class="sgc-toc-level-3">
<a href="#/Text/Dan_Intro#sigil_toc_id_7">e. Babylon, Persia-Media, Greece and beyond (Daniel 7 – 12)</a>
</div>
<div class="sgc-toc-level-3">
<a href="#/Text/Dan_Intro#sigil_toc_id_8">f. Conclusion and implications</a>
</div>
</div>
<div class="sgc-toc-level-2">
<a href="#/Text/Dan_Intro#sigil_toc_id_9">2. Literary elements</a>
<div class="sgc-toc-level-3">
<a href="#/Text/Dan_Intro#sigil_toc_id_10">a. Overview</a>
</div>
<div class="sgc-toc-level-3">
<a href="#/Text/Dan_Intro#sigil_toc_id_11">b. Hebrew and Aramaic text of Daniel</a>
</div>
<div class="sgc-toc-level-3">
<a href="#/Text/Dan_Intro#sigil_toc_id_12">c. Greek and Latin texts of Daniel</a>
</div>
<div class="sgc-toc-level-3">
<a href="#/Text/Dan_Intro#sigil_toc_id_13">d. Characters</a>
</div>
<div class="sgc-toc-level-3">
<a href="#/Text/Dan_Intro#sigil_toc_id_14">e. Plot</a>
</div>
<div class="sgc-toc-level-3">
<a href="#/Text/Dan_Intro#sigil_toc_id_15">f. Imagery</a>
</div>
<div class="sgc-toc-level-3">
<a href="#/Text/Dan_Intro#sigil_toc_id_16">g. Genre</a>
</div>
<div class="sgc-toc-level-3">
<a href="#/Text/Dan_Intro#sigil_toc_id_17">h. Narrator</a>
</div>
<div class="sgc-toc-level-3">
<a href="#/Text/Dan_Intro#sigil_toc_id_18">i. Authorship, date and setting</a>
</div>
</div>
<div class="sgc-toc-level-2">
<a href="#/Text/Dan_Intro#sigil_toc_id_19">3. Canonical elements</a>
<div class="sgc-toc-level-3">
<a href="#/Text/Dan_Intro#sigil_toc_id_20">a. Overview</a>
</div>
<div class="sgc-toc-level-3">
<a href="#/Text/Dan_Intro#sigil_toc_id_21">b. The Old Testament canon</a>
</div>
<div class="sgc-toc-level-3">
<a href="#/Text/Dan_Intro#sigil_toc_id_22">c. Daniel’s placement in the Old Testament canon</a>
</div>
<div class="sgc-toc-level-3">
<a href="#/Text/Dan_Intro#sigil_toc_id_23">d. Daniel’s canonical significance</a>
</div>
</div>
<div class="sgc-toc-level-2">
<a href="#/Text/Dan_Intro#sigil_toc_id_24">4. Theological elements</a>
<div class="sgc-toc-level-3">
<a href="#/Text/Dan_Intro#sigil_toc_id_25">a. Overview</a>
</div>
<div class="sgc-toc-level-3">
<a href="#/Text/Dan_Intro#sigil_toc_id_26">b. God, the revealer of life-shaping truth</a>
</div>
<div class="sgc-toc-level-3">
<a href="#/Text/Dan_Intro#sigil_toc_id_27">c. God, history’s everlasting ruler</a>
</div>
<div class="sgc-toc-level-3">
<a href="#/Text/Dan_Intro#sigil_toc_id_28">d. God, the ruler whose kingdom rises</a>
</div>
<div class="sgc-toc-level-3">
<a href="#/Text/Dan_Intro#sigil_toc_id_29">e. God, his suffering people’s protector</a>
</div>
<div class="sgc-toc-level-3">
<a href="#/Text/Dan_Intro#sigil_toc_id_30">f. God, the one to whom all must answer</a>
</div>
</div>
<div class="sgc-toc-level-2">
<a href="#/Text/Dan_Intro#sigil_toc_id_31">5. Formational elements</a>
<div class="sgc-toc-level-3">
<a href="#/Text/Dan_Intro#sigil_toc_id_32">a. Overview</a>
</div>
<div class="sgc-toc-level-3">
<a href="#/Text/Dan_Intro#sigil_toc_id_33">b. The New Testament</a>
</div>
<div class="sgc-toc-level-3">
<a href="#/Text/Dan_Intro#sigil_toc_id_34">c. Contemporary times</a>
</div>
</div>
</div>
<div class="sgc-toc-level-1s">
<span href="#/Text/Dan_Analysis" title="Link target outside of Sample"><span class="bold">Analysis</span></span>
</div>
<div class="sgc-toc-level-1s">
<span href="#/Text/Dan_ch01" title="Link target outside of Sample"><span class="bold">Commentary</span></span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Dan_ch01#sigil_toc_id_35" title="Link target outside of Sample">1. God gives exile and grace (1:1–21)</span>
<div class="sgc-toc-level-2">
<span href="#/Text/Dan_ch01#sigil_toc_id_36" title="Link target outside of Sample">A. God gives his people into Nebuchadnezzar’s hands (1:1–7)</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/Dan_ch01#sigil_toc_id_37" title="Link target outside of Sample">B. God gives his servants grace (1:8–21)</span>
</div>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Dan_ch02" title="Link target outside of Sample">2. God gives wisdom, might and hidden knowledge (2:1–49)</span>
<div class="sgc-toc-level-2">
<span href="#/Text/Dan_ch02#sigil_toc_id_38" title="Link target outside of Sample">A. Nebuchadnezzar’s troubling dream and hasty decree (2:1–13)</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/Dan_ch02#sigil_toc_id_39" title="Link target outside of Sample">B. God reveals hidden knowledge (2:14–23)</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/Dan_ch02#sigil_toc_id_40" title="Link target outside of Sample">C. Daniel reveals Nebuchadnezzar’s dream and its interpretation (2:24–45)</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/Dan_ch02#sigil_toc_id_41" title="Link target outside of Sample">D. Nebuchadnezzar praises God and promotes Daniel and his friends (2:46–49)</span>
</div>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Dan_ch03" title="Link target outside of Sample">3. God delivers his servants from the flames (3:1–30)</span>
<div class="sgc-toc-level-2">
<span href="#/Text/Dan_ch03#sigil_toc_id_42" title="Link target outside of Sample">A. Nebuchadnezzar’s golden statue (3:1–7)</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/Dan_ch03#sigil_toc_id_43" title="Link target outside of Sample">B. Conflict in the court (3:8–12)</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/Dan_ch03#sigil_toc_id_44" title="Link target outside of Sample">C. Confrontation, confession and condemnation (3:13–23)</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/Dan_ch03#sigil_toc_id_45" title="Link target outside of Sample">D. Deliverance, confession and decree (3:24–30)</span>
</div>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Dan_ch04" title="Link target outside of Sample">4. God humbles the proud (4:1–37)</span>
<div class="sgc-toc-level-2">
<span href="#/Text/Dan_ch04#sigil_toc_id_46" title="Link target outside of Sample">A. Nebuchadnezzar’s letter to his people (4:1–3)</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/Dan_ch04#sigil_toc_id_47" title="Link target outside of Sample">B. Another helpful troubling dream (4:4–18)</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/Dan_ch04#sigil_toc_id_48" title="Link target outside of Sample">C. A reluctant interpreter and some wise counsel (4:19–27)</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/Dan_ch04#sigil_toc_id_49" title="Link target outside of Sample">D. God humbles Nebuchadnezzar (4:28–33)</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/Dan_ch04#sigil_toc_id_50" title="Link target outside of Sample">E. God heals and restores Nebuchadnezzar (4:34–37)</span>
</div>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Dan_ch05" title="Link target outside of Sample">5. The handwriting on the wall: the end of Babylon (5:1–31)</span>
<div class="sgc-toc-level-2">
<span href="#/Text/Dan_ch05#sigil_toc_id_51" title="Link target outside of Sample">A. The handwriting on the wall (5:1–12)</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/Dan_ch05#sigil_toc_id_52" title="Link target outside of Sample">B. Daniel interprets the writing (5:13–28)</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/Dan_ch05#sigil_toc_id_53" title="Link target outside of Sample">C. Honours at the eleventh hour (5:29–31)</span>
</div>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Dan_ch06" title="Link target outside of Sample">6. God saves Daniel from the lions (6:1–28)</span>
<div class="sgc-toc-level-2">
<span href="#/Text/Dan_ch06#sigil_toc_id_54" title="Link target outside of Sample">A. New regime, new dangers (6:1–9)</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/Dan_ch06#sigil_toc_id_55" title="Link target outside of Sample">B. Daniel’s faithfulness and the king’s anguish (6:10–18)</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/Dan_ch06#sigil_toc_id_56" title="Link target outside of Sample">C. God delivers Daniel (6:19–24)</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/Dan_ch06#sigil_toc_id_57" title="Link target outside of Sample">D. Darius’s decree and Daniel’s security (6:25–28)</span>
</div>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Dan_ch07" title="Link target outside of Sample">7. The Ancient of Days and the Son of Man (7:1–28)</span>
<div class="sgc-toc-level-2">
<span href="#/Text/Dan_ch07#sigil_toc_id_58" title="Link target outside of Sample">A. Four beasts from the sea (7:1–8)</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/Dan_ch07#sigil_toc_id_59" title="Link target outside of Sample">B. The Ancient of Days and the Son of Man: earth’s true co-regents (7:9–14)</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/Dan_ch07#sigil_toc_id_60" title="Link target outside of Sample">C. The vision’s interpretation and Daniel’s reaction (7:15–28)</span>
</div>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Dan_ch08" title="Link target outside of Sample">8. A ram, a goat, a horn and a temple (8:1–27)</span>
<div class="sgc-toc-level-2">
<span href="#/Text/Dan_ch08#sigil_toc_id_61" title="Link target outside of Sample">A. A ram, a goat and a temple: Daniel’s vision (8:1–14)</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/Dan_ch08#sigil_toc_id_62" title="Link target outside of Sample">B. Gabriel’s interpretation and Daniel’s reaction (8:15–27)</span>
</div>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Dan_ch09" title="Link target outside of Sample">9. Daniel’s prayer and heaven’s answer (9:1–27)</span>
<div class="sgc-toc-level-2">
<span href="#/Text/Dan_ch09#sigil_toc_id_63" title="Link target outside of Sample">A. Preparation for prayer (9:1–3)</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/Dan_ch09#sigil_toc_id_64" title="Link target outside of Sample">B. Daniel’s confession of sin and trust (9:4–15)</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/Dan_ch09#sigil_toc_id_65" title="Link target outside of Sample">C. Daniel’s specific requests (9:16–19)</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/Dan_ch09#sigil_toc_id_66" title="Link target outside of Sample">D. Heaven’s answer: Gabriel returns (9:20–27)</span>
</div>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Dan_ch10" title="Link target outside of Sample">10. From Cyrus to resurrection: Daniel’s longest vision (10:1 – 12:13)</span>
<div class="sgc-toc-level-2">
<span href="#/Text/Dan_ch10#sigil_toc_id_67" title="Link target outside of Sample">A. Terror and comfort: introduction to the vision (10:1 – 11:1)</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/Dan_ch10#sigil_toc_id_68" title="Link target outside of Sample">B. Centuries of triumph and trial (11:2 – 12:4)</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/Dan_ch10#sigil_toc_id_69" title="Link target outside of Sample">C. Resting and rising (12:5–13)</span>
</div>
</div>
<div class="sgc-toc-level-1s">
<span href="#/Text/Dan_Notes" title="Link target outside of Sample">Notes</span>
</div>
<div class="sgc-toc-level-1s">
<span href="#/Text/praise" title="Link target outside of Sample"><span class="bold">Praise for Tyndale Commentaries</span></span>
</div>
<div class="sgc-toc-level-1s">
<span href="#/Text/ata" title="Link target outside of Sample"><span class="bold">About the Author</span></span>
</div>
<div class="sgc-toc-level-1s">
<span href="#/Text/series" title="Link target outside of Sample"><span class="bold">Tyndale Commentary Volumes</span></span>
</div>
<div class="sgc-toc-level-1s">
<span href="#/Text/moreivp" title="Link target outside of Sample"><span class="bold">More Titles from InterVarsity Press</span></span>
</div>
<div class="sgc-toc-level-1s">
<span href="#/Text/selector" title="Link target outside of Sample"><span class="bold">IVP Academic Textbook Selector</span></span>
</div>
<div class="sgc-toc-level-1s">
<span href="#/Text/copyright" title="Link target outside of Sample"><span class="bold">Copyright</span></span>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Dan_contents.vue?53eb70a6